import spec from '@applitools/spec-driver-webdriverio';
import { dependencies } from '../../../package.json';
import { getSessionPlayer } from '../../commons/getSessionPlayerRequire';
import type { Core } from '@applitools/eyes-sdk-core';
import type { SpecType } from 'clickim/src/background/eyeSdkService';
import type { ApplitoolsIntegrationData } from 'clickim/src/common/api/testimVisualTestingApi';

class EyeSdkService {
    private sdk: Core<SpecType, 'ufg'>;

    constructor() {
        const sdkVersion = dependencies['@applitools/eyes-sdk-core'] || 'N/A';
        const { makeSDK } = require('@applitools/eyes-sdk-core') as typeof import('@applitools/eyes-sdk-core');

        this.sdk = makeSDK({
            name: 'Testim.io',
            version: `4.0.1/eyes-sdk-core/${sdkVersion}`,
            spec,
        });
    }

    public async getManager(useVisualGrid: boolean | undefined, concurrency: number | undefined, batchId: string, applitoolsIntegrationData: ApplitoolsIntegrationData) {
        const { EyeSdkBuilder } = getSessionPlayer();
        // @ts-expect-error Applitools types are wrong once again https://github.com/applitools/eyes.sdk.javascript1/blob/master/js/packages/eyes-sdk-core/src/make-manager.js#L6
        const manager = await this.sdk.makeManager({ type: useVisualGrid ? 'ufg' : 'classic', concurrency });
        EyeSdkBuilder.rememberCreatedBatch(batchId, applitoolsIntegrationData);
        return manager;
    }
}

export const eyeSdkService = new EyeSdkService();
